<!--this is a work in progress as it was broken off of this ticket. The styling still needs to be done.-->

<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<ng-select [multiple]="true" [(ngModel)]="selectedSkills" [addTag]="true">
</ng-select>
